import { IDeepCopy } from '@common/interfaces/i-deep-copy';
import { IToString } from '@common/interfaces/i-to-string';

import { Table } from './table';

export class Address implements IDeepCopy<Address>, IToString {
    constructor() {}

    protected _model: Array<any> = null;

    public updateFrom(newAddress: Address) {
        this.administrativeArea = newAddress.administrativeArea;
        this.city = newAddress.city;
        this.country = newAddress.country;
        this.formattedAddress = newAddress.formattedAddress;
        this.lat = newAddress.lat;
        this.locality = newAddress.locality;
        this.locationName = newAddress.locationName;
        this.long = newAddress.long;
        this.neighborhood = newAddress.neighborhood;
        this.placeId = newAddress.placeId;
        this.postalCode = newAddress.postalCode;
        this.shortCountry = newAddress.shortCountry;
        this.shortState = newAddress.shortState;
        this.state = newAddress.state;
        this.streetAddress = newAddress.streetAddress;
        this.subLocality = newAddress.subLocality;
        this.title = newAddress.title;
    }

    public equals(target: Address): boolean {
        if (!target) {
            return false;
        }
        if (!this.placeId || this.placeId === '') {
            return target.formattedAddress === this.formattedAddress;
        }

        return target.placeId === this.placeId;
    }

    public isManualEditMode: boolean = false;

    public hasManualEdits(oldValue: Address): boolean {
        if (!oldValue) {
            this.isManualEditMode = false;
            return false;
        }
        this.isManualEditMode =
            !!this.isManualEditMode ||
            this.locationName !== oldValue.locationName ||
            this.streetAddress !== oldValue.streetAddress ||
            this.city !== oldValue.city ||
            this.country !== oldValue.country ||
            this.state !== oldValue.state;
        return this.isManualEditMode;
    }

    public setAddressSubField(subField: string, data: string | Table | Address) {
        if (data instanceof Address) return;
        if (data instanceof Table) return;
        if (subField === 'country') {
            this.country = data;
        }
        if (subField === 'locationName') {
            this.locationName = data;
        }
        if (subField === 'city') {
            this.city = data;
        }
        if (subField === 'state') {
            this.state = data;
        }
        if (subField === 'streetAddress') {
            this.streetAddress = data;
        }
        this.updateFormattedAddress();
    }

    public updateFormattedAddress() {
        const tmpAddressArray: Array<string> = [this.locationName, this.streetAddress, this.city, this.state, this.country];
        this.formattedAddress = tmpAddressArray.filter(elem => !!elem).join(', ');
        this.isManualEditMode = true;
    }

    public getAddressForPlacePredictions(): string {
        const tmpAddressArray: Array<string> = [this.locationName ? this.locationName : this.streetAddress, this.city, this.state, this.country];
        const formattedAddress = tmpAddressArray.filter(elem => !!elem).join(', ');
        return formattedAddress;
    }

    public clearGoogleFields() {
        this.administrativeArea = '';
        this.lat = 0;
        this.long = 0;
        this.placeId = '';
        this.shortState = '';
        this.shortCountry = '';
        this.locality = '';
        this.subLocality = '';
        this.neighborhood = '';
        this.title = '';
        this.postalCode = '';
    }

    public clear() {
        this.administrativeArea = '';
        this.streetAddress = '';
        this.locationName = '';
        this.city = '';
        this.state = '';
        this.country = '';
        this.lat = 0;
        this.long = 0;
        this.placeId = '';
        this.formattedAddress = '';
        this.shortState = '';
        this.shortCountry = '';
        this.locality = '';
        this.subLocality = '';
        this.neighborhood = '';
        this.title = '';
        this.postalCode = '';
    }

    public streetAddress: string = '';
    public locationName: string = '';
    public administrativeArea: string = '';
    public city: string = '';
    public state: string = '';
    public country: string = '';
    public lat: number = 0;
    public long: number = 0;
    public placeId: string = '';
    private _formattedAddress: string = '';
    public get formattedAddress(): string {
        return this._formattedAddress;
    }
    public set formattedAddress(value: string) {
        this._formattedAddress = value;
    }
    public shortState: string = '';
    public shortCountry: string = '';
    public locality: string = '';
    public subLocality: string = '';
    public neighborhood: string = '';
    public title: string = '';
    public postalCode: string = '';

    public deepCopy(): Address {
        const ret = new Address();
        ret.updateFrom(this);
        return ret;
    }

    public toString(): string {
        // return concatentation of all fields
        const ret = [];
        if (this.locationName) ret.push(this.locationName);
        if (this.streetAddress) ret.push(this.streetAddress);
        if (this.postalCode) ret.push(this.postalCode);
        if (this.neighborhood) ret.push(this.neighborhood);
        if (this.city) ret.push(this.city);
        if (this.state) ret.push(this.state);
        if (this.country) ret.push(this.country);
        return ret.join(', ');
    }
}
